import React from 'react';
import { getDataLayer } from 'utils';

let pushToGTM = () => {};
const dataLayer = getDataLayer();
if (dataLayer) {
    pushToGTM = data => dataLayer.push(data);
}

export default function withGTM(Component) {
    return props => <Component pushToGTM={pushToGTM} {...props} />;
}
